<template>
  <v-container class="d-flex justify-center">
    <v-card
      style="
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 10px;
        border-radius: 10px;
        margin-top: 3px;
      "
    >
      <v-card
        style="
          max-width: 800px;
          padding: 0;
          margin-top: 10px;
          margin-bottom: 10px;
          border-radius: 10px;
        "
        elevation="0"
      >
        <v-row>
          <v-col> </v-col>
        </v-row>

        <div style="width: 100%; text-align: center;">
          <img
            class="logo-header"
          
            :src="require('@/assets/BAS_BambooHR.svg')"
            alt="Company Logo"
          />
          
        </div>

        <div style="width: 100%; text-align: center; padding: 20px 0px 10px 0px;">
          <span
            style="color: #4A4A4A; font-size: 40px; font-weight: 500;"
          >
            Marketplace Integration
          </span>
        </div>

        <v-card class="pa-5 mb-5" style="border-radius: 10px; ">
          <!-- <v-row>
          <v-col>
            <span style=" font-family: fields, sans-serif; font-style: normal;
            color: #2e7917;  font-size:larger; font-weight: bolder; font-style: normal;"
            >
              Get a quote! It only takes a few seconds!
            </span>
            <p style="font-family: 'Inter', sans-serif;">We’ll gather a few pieces of information and email you a service quote.</p>
            <v-btn @click="GetQuote" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
              Get Quote
            </v-btn>
          </v-col>
        </v-row> -->

          <v-row style="margin-left: 0px; margin-top: 10px;">
            <span class="font-weight-bold header-text1"
              >Accept Quote & Begin Setup</span
            >
          </v-row>

          <v-row style="margin-top: 20px; margin-left: 2px;">
            <span style="font-size: 15px; font-weight: 500; color: #4A4A4A;">
              Click the "Begin Integration" button below, which will require 2
              steps:
            </span>
          </v-row>
           <v-row style="margin-top: 20px; margin-bottom: 20px; margin-left: 65px; ">
            <ol>
                <li class="content-text" style="font-weight: 700;">Login to your BambooHR Account
                    <br><span style="font-weight: 500;">This will begin the authorization to connect your BambooHR account
                    to BAS MyEnroll.com COBRA Platform. </span></li>
                <li class="content-text" style="font-weight: 700;">Follow the guided MyEnroll.com Account Setup
                    <br><span style="font-weight: 500;">We will collect a bit more information about your COBRA
                    requirements and complete contracting.</span>
                </li>
            </ol>
           </v-row>
        
        </v-card>

        <v-card class="pa-5" style="border-radius: 10px">
          <v-row>
            <v-col>
              <h3
                class="font-weight-bold header-text1"
                style="color: #2e7917;"
              >
                Let’s get started...
              </h3>
              <p >
                We’ll guide you through setting up your COBRA administration
                integration.
              </p>

              <p
                v-if="showQuoteError"
                style="
                  color: red;
                  font-size: 15px;
                  margin-top: 0;
                  margin-bottom: 20px;
                  max-width: 335px;
                "
              >
                Quote ID doesn't exist. Please click on the Get Quote button.
              </p>
              <p style="margin: 0">Are you a BambooHR Administrator?</p>

              <div>
                <div style="display: flex; align-items: center; gap: 10px">
                  <v-radio-group
                    v-model="isAdmin"
                    style="
                      margin-bottom: 0;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                    "
                    @change="onAdminChange"
                  >
                    <v-radio
                      label="Yes"
                      value="yes"
                      style="color: black"
                    ></v-radio>
                    <v-radio
                      :label="'No (This setup only works if you have BambooHR Administrator permissions.)'"
                      value="no"
                    ></v-radio>
                  </v-radio-group>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: center;
                    margin-top: 10px;
                  "
                >
                  <v-btn
                    v-if="isAdmin === 'yes'"
                    color="green"
                    style="
                      color: white;
                      border-radius: 0px;
                      border: 2px solid #2e7917;
                      text-transform: none;
                      font-weight: bold;
                      min-width: 120px;
                      padding: 10px 20px;
                      box-shadow: 0 2px 4px rgba(46, 121, 23, 0.15);
                    "
                    :disabled="isAdmin === ''"
                    @click="showSubdomainDialog = true"
                  >
                    BEGIN INTEGRATION
                  </v-btn>
                  <v-btn
                    v-else-if="isAdmin === 'no'"
                    style="
                      background-color: red;
                      color: white;
                      border-radius: 20px;
                      border: 1px solid grey;
                      text-transform: none;
                      font-weight: normal;
                    "
                    @click="showNonAdminDialog = true"
                  >
                    Cancel
                  </v-btn>
                  <v-dialog
                    v-model="showNonAdminDialog"
                    max-width="450px"
                    persistent
                  >
                    <v-card>
                      <v-card-title class="headline" 
                        >Non-Administrator Notice</v-card-title
                      >
                      <v-card-text >
                        As a non-administrator, you do not have the required
                        permissions to complete this integration setup. By
                        clicking "Continue", you will exit this setup
                        application. If you wish to remain and proceed with
                        account integration, click "Return" to go back.
                      </v-card-text>
                      <v-card-actions
                        class="d-flex justify-center"
                        style="gap: 12px"
                      >
                        <v-btn
                          color="primary"
                          @click="showNonAdminDialog = false"
                          >Return</v-btn
                        >
                        <v-btn
                          color="red"
                          style="color: white !important"
                          @click="redirectToCobra"
                          >Continue</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <div class="logo-wrapper" style="width:100%; margin: 0 auto; padding: 10px;">
          <div><img
            class="logos-footer"
            style="height: 43px"
            :src="require('@/assets/MyEnrollLogo_Variation.svg')"
            alt="MyEnroll Logo"
          /></div>
          <div class="logo-wrapper" style="max-width: 350px; margin: 0 auto; padding: 10px;">
            <img
              :src="require('@/assets/Badge_Hipaa.svg')"
              alt="HIPAA Badge"
              style="height: 100px; flex: 1; max-width: 150px;"
            />
            <img
              :src="require('@/assets/Badge_Soc1Type2.svg')"
              alt="SOC1 Type 2 Badge"
              style="height: 100px; flex: 1; max-width: 150px;"
            />
            <img
              :src="require('@/assets/Badge_Soc2Type2.svg')"
              alt="SOC2 Type 2 Badge"
              style="height: 100px; flex: 1; max-width: 150px;"
            />
          </div>
          <div><img
            class="logos-footer"
            style="height: 48px"
            :src="require('@/assets/CCSLogo_Variation.svg')"
            alt="CCS Logo"
          /></div>
        </div>

      </v-card>

      <v-dialog
        v-model="showSubdomainDialog"
        persistent
        max-width="600px"
        scrollable
      >
        <v-card
          style="
            max-height: 70vh;
            overflow-y: auto;
            border-radius: 16px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
            margin: auto;
          "
        >
          <v-card-title class="headline" >
            Enter Your Details
          </v-card-title>

          <v-card-text>
            <span >First Name</span>
            <v-row class="pa-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="firstName"
                  outlined
                  dense
                  required
                  :rules="[(v) => !!v || 'First Name is required']"
                  style="
                    max-width: 303px;
                    height: 40px;
                    margin-top: 10px;
                    margin-left: 10px;
                    margin-bottom: 20px;
                  "
                  class="custom-input"
                  :error-messages="!firstName ? ['First Name is required'] : []"
                ></v-text-field>
              </v-col>
            </v-row>
            <span >Last Name</span>
            <v-row class="pa-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="lastName"
                  outlined
                  dense
                  required
                  :rules="[(v) => !!v || 'Last Name is required']"
                  style="
                    max-width: 303px;
                    height: 40px;
                    margin-top: 10px;
                    margin-left: 10px;
                    margin-bottom: 20px;
                  "
                  class="custom-input"
                  :error-messages="!lastName ? ['Last Name is required'] : []"
                ></v-text-field>
              </v-col>
            </v-row>
            <span >BambooHR Subdomain</span>
            <v-row class="pa-0">
              <v-col class="pa-0">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                  "
                >
                  <v-text-field
                    v-model="subdomain"
                    outlined
                    dense
                    required
                    style="
                      max-width: 303px;
                      height: 40px;
                      margin-top: 10px;
                      margin-left: 10px;
                      margin-bottom: 20px;
                    "
                    :rules="[validSubdomain]"
                    :error-messages="
                      validSubdomain(subdomain) !== true
                        ? [validSubdomain(subdomain)]
                        : []
                    "
                  >
                    <template v-slot:append>
                      <span style="font-weight: 600; color: #2e7917">
                        .bamboohr.com
                      </span>
                    </template>
                  </v-text-field>
                  <v-btn
                    :loading="loading"
                    @click="handleClick"
                    outlined
                    rounded
                    small
                    :style="{
                      color:
                        subdomainTestStatus === 'success'
                          ? '#2e7917'
                          : subdomainTestStatus === 'failure'
                          ? '#d32f2f'
                          : '#1976d2',
                      borderColor:
                        subdomainTestStatus === 'success'
                          ? '#2e7917'
                          : subdomainTestStatus === 'failure'
                          ? '#d32f2f'
                          : '#1976d2',
                      backgroundColor: 'white',
                      textTransform: 'none',
                      fontWeight: '500',
                      fontSize: '13px',
                      padding: '0 20px',
                      height: '36px',
                      minWidth: '100px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      marginTop: '-10px',
                    }"
                    class="test-btn"
                  >
                    {{
                      subdomainTestStatus === "success"
                        ? "✓ Valid"
                        : subdomainTestStatus === "failure"
                        ? "✗ Invalid"
                        : "Test"
                    }}
                    <template v-slot:loader>
                      <v-progress-circular
                        size="18"
                        indeterminate
                      ></v-progress-circular>
                    </template>
                  </v-btn>
                </div>
                <div
                  v-if="subdomainTestStatus === 'failure'"
                  style="max-width: 303px; margin-left: 10px; margin-top: 2px"
                >
                  <span
                    style="font-size: 15px; color: #d32f2f; white-space: nowrap"
                    >⚠️ That subdomain doesn’t look right.</span
                  >
                  <div
                    style="
                      font-size: 15px;
                      color: #d32f2f;
                      margin-top: 2px;
                      white-space: nowrap;
                    "
                  >
                    Please double-check your spelling and try again.
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Integration Info Text -->
            <v-row style="margin-top: 20px; margin-bottom: 10px">
              <v-col>
                <div
                  style="
                    background: #f5f5f5;
                    border-radius: 8px;
                    padding: 16px;
                    color: #333;
                  "
                >
                  <h3
                    style="
                      margin-top: 0;
                      color: #2e7917;
                      font-size: 19px;
                      font-weight: 700;
                    "
                  >
                    Connect BambooHR to BAS COBRA System
                  </h3>
                  <p style="margin-bottom: 8px">
                    To proceed, you’ll need to enable a secure connection
                    between your BambooHR account and the BAS COBRA System.
                  </p>
                  <p style="margin-bottom: 0">
                    This integration allows BAS to automatically detect and
                    import COBRA-related activity from BambooHR — such as
                    qualifying events and employee status changes into the BAS
                    COBRA System for timely and accurate processing.
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions
            class="d-flex justify-center"
            style="
              gap: 12px;
              padding: 20px;
              flex-direction: column;
              align-items: center;
            "
          >
            <!-- Success Dialog -->
            <v-dialog v-model="showSuccessDialog" max-width="500px" persistent>
              <v-card>
                <v-card-title class="headline" 
                  >🎉 Success!</v-card-title
                >
                <v-card-text style="text-align: center">
                  <div
                    style="
                      font-size: 15px;
                      margin-top: 8px;
                      color: #2e7917;
                      font-weight: 600;
                    "
                  >
                    Your BambooHR connection is working perfectly.
                  </div>
                  <div style="font-size: 15px; margin-top: 4px; color: #333">
                    Click the blue "Begin Integration" button below to continue
                    setting up your integration.
                  </div>
                </v-card-text>
                <v-card-actions class="d-flex justify-center" style="gap: 12px">
                  <v-btn
                    style="
                      background: none;
                      color: black;
                      min-width: 120px;
                      padding: 10px 20px;
                      box-shadow: none;
                      border: 1px solid black;
                    "
                    @click="showSuccessDialog = false"
                    >GO BACK</v-btn
                  >
                  <v-btn
                    color="green"
                    style="
                      color: white;
                      border-radius: 0px;
                      border: 2px solid #2e7917;
                      text-transform: none;
                      font-weight: bold;
                      min-width: 120px;
                      padding: 10px 20px;
                      box-shadow: 0 2px 4px rgba(46, 121, 23, 0.15);
                    "
                    @click="beginIntegration"
                    >BEGIN INTEGRATION</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <div
              style="
                display: flex;
                justify-content: center;
                gap: 16px;
                width: 100%;
              "
            >
              <div
                v-if="isLockedOut"
                style="
                  color: #d32f2f;
                  font-size: 15px;
                  margin-bottom: 10px;
                  text-align: center;
                  width: 100%;
                "
              >
                Integration is blocked due to too many failed subdomain
                attempts. Please try again in
                {{ lockoutMinutesLeft }} minute(s).
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      logo3: require("@/assets/CCSLogo_Color.svg"),
      logo1: require("@/assets/BASLogo_Color.svg"),
      logo2: require("@/assets/bamboohr-logo-green.svg"),
      isAdmin: "",
      quoteId: "",
      quote_exists: "0", //0 not exists, 1 exists
      showQuoteError: false,
      showSubdomainDialog: false,
      showNonAdminDialog: false,
      showSuccessDialog: false,
      subdomain: "",
      firstName: "",
      lastName: "",
      subdomainTestStatus: "", // 'success', 'failure', or ''

      loading: false,
      isLockedOut: false,
      lockoutMinutesLeft: 5,
    };
  },
  watch: {
    subdomain() {
      this.subdomainTestStatus = "";
    },
  },
  computed: {
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },
  },

  methods: {
    onAdminChange(value) {
      if (value === "no") {
        this.showNonAdminDialog = true;
      }
    },
    redirectToCobra() {
      window.location.href = "https://www.basusa.com/cobra";
    },
    GetQuote() {
      this.$router.push({ name: "ServiceQuoteForm" });
    },

    beginIntegration() {
      const clientId =
        "developer_portal-9e366ea90fd3b98d5b4a61531c48dd3ee2cb6c3c";
      const state = Math.random().toString(36).substring(7);
      const scope = "openid+legacy.login+email+benefit";
      const redirectUri = `https://www.myenroll.com/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
      //const redirectUri = `https://www.bastest.com/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
      //const redirectUri = `http://localhost/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
      //const redirectUri =  this.methodUrl+`/bamboohr_backend/Bamboohr_sso_page.aspx`;
      this.setCookie("subdomain_value", this.subdomain);
      this.setCookie("first_name", this.firstName);
      this.setCookie("last_name", this.lastName);
      const authUrl = `https://${
        this.subdomain
      }.bamboohr.com/authorize.php?request=authorize&state=${state}&response_type=code&scope=${scope}&client_id=${clientId}&redirect_uri=${encodeURIComponent(
        redirectUri
      )}`;

      window.location.href = authUrl;
    },
    validSubdomain(value) {
      const pattern = /^[A-Za-z0-9-]+$/;
      if (!value) {
        return "Subdomain is required";
      } else if (value.length < 3 || value.length > 100) {
        return "Subdomain must be between 3 and 100 characters";
      } else if (!pattern.test(value)) {
        return "Subdomain contains invalid characters. Allowed characters: A-Z, a-z, 0-9";
      } else {
        this.url = `https://${value}.bamboohr.com`;
        return true;
      }
    },

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    },

    async handleClick() {
      // Check lockout status
      const lockoutInfo = JSON.parse(
        localStorage.getItem("subdomainLockout") || "{}"
      );
      console.log(
        "[Lockout Debug] handleClick - lockoutInfo:",
        lockoutInfo,
        "Current Time:",
        Date.now(),
        new Date().toString()
      );
      if (lockoutInfo.lockedUntil && Date.now() < lockoutInfo.lockedUntil) {
        this.isLockedOut = true;
        this.lockoutMinutesLeft = Math.ceil(
          (lockoutInfo.lockedUntil - Date.now()) / 60000
        );
        console.log(
          "[Lockout Debug] User is locked out until:",
          lockoutInfo.lockedUntil,
          "Minutes left:",
          this.lockoutMinutesLeft
        );
        return;
      } else if (
        lockoutInfo.lockedUntil &&
        Date.now() >= lockoutInfo.lockedUntil
      ) {
        // Lockout expired, reset
        localStorage.removeItem("subdomainLockout");
        this.isLockedOut = false;
      }
      this.loading = true;

      try {
        const response = await axios.post(
          this.methodUrl + "/bamboohr_backend/CheckUrl.aspx",
          new URLSearchParams({ url: this.url }).toString(),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        );

        if (response.data === "success") {
          this.subdomainTestStatus = "success";
          if (this.firstName && this.lastName && this.subdomain) {
            this.showSuccessDialog = true;
          }
          localStorage.removeItem("subdomainAttempts");
        } else {
          this.subdomainTestStatus = "failure";
          this.failureDialog = true;
          this.handleFailure();
        }
      } catch (error) {
        console.error("Error:", error);
        this.subdomainTestStatus = "failure";
        this.failureDialog = true;
        this.handleFailure();
      } finally {
        this.loading = false;
      }
    },

    handleFailure() {
      // Track failed attempts in localStorage
      let attempts = parseInt(
        localStorage.getItem("subdomainAttempts") || "0",
        10
      );
      attempts += 1;
      localStorage.setItem("subdomainAttempts", attempts);
      console.log("[Lockout Debug] Failed attempts:", attempts);
      if (attempts > 5) {
        // Set lockout for 5 minutes
        const lockedUntil = Date.now() + 5 * 60 * 1000;
        localStorage.setItem(
          "subdomainLockout",
          JSON.stringify({ lockedUntil })
        );
        this.isLockedOut = true;
        this.lockoutMinutesLeft = 5;
        console.log(
          "[Lockout Debug] Lockout set. lockedUntil:",
          lockedUntil,
          "Current Time:",
          Date.now(),
          new Date().toString()
        );
      }
    },
  },
  mounted() {
    // Check lockout status on mount
    const lockoutInfo = JSON.parse(
      localStorage.getItem("subdomainLockout") || "{}"
    );
    console.log(
      "[Lockout Debug] mounted - lockoutInfo:",
      lockoutInfo,
      "Current Time:",
      Date.now(),
      new Date().toString()
    );
    if (lockoutInfo.lockedUntil && Date.now() < lockoutInfo.lockedUntil) {
      this.isLockedOut = true;
      this.lockoutMinutesLeft = Math.ceil(
        (lockoutInfo.lockedUntil - Date.now()) / 60000
      );
      // Optionally, update minutes left every minute
      this.lockoutInterval = setInterval(() => {
        const info = JSON.parse(
          localStorage.getItem("subdomainLockout") || "{}"
        );
        console.log(
          "[Lockout Debug] interval - lockoutInfo:",
          info,
          "Current Time:",
          Date.now(),
          new Date().toString()
        );
        if (info.lockedUntil && Date.now() < info.lockedUntil) {
          this.lockoutMinutesLeft = Math.ceil(
            (info.lockedUntil - Date.now()) / 60000
          );
        } else {
          this.isLockedOut = false;
          clearInterval(this.lockoutInterval);
          localStorage.removeItem("subdomainLockout");
          localStorage.removeItem("subdomainAttempts");
        }
      }, 10000);
    }
  },
};
</script>

<style scoped>
html,
body,
.v-application {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}
.logo {
  width: 100px; /* Adjust logo size */
  margin: auto;
}
.logo-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.logo-header {
  flex: 1;
  padding: 5px;
  max-width: 400px;
}
.logos-footer {
  flex: 1;
  padding: 5px;
  max-width: 100%;
}
.header-text1 {
  color: #2e7917;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
}
.content-text {
  font-size: 15px;
  
  color: #4A4A4A;
}
@media screen and (max-width: 767px) {
  .logo-header {
    max-width: 400px;
    padding: 10px;
  }
  .logo-wrapper {
    flex-direction: column;
    text-align: center;
    padding-bottom: 15px;
  }
  .logos-footer {
    flex: 1;
    padding: 5px;
     max-width: 120px;
  }
}
</style>